<script setup lang="ts">
import { LogIn } from "@lucide/vue";
import { onMounted, ref } from "vue";
import { signInUrl } from "@/api/client";
import { Button } from "@/components/ui/button";
import { t } from "@/copy/strings";
import BrandMark from "./BrandMark.vue";

/**
 * Not signed in. First visits (and deep links such as /approvals/:id) go
 * straight to Keycloak; after an explicit sign-out we stay here instead of
 * bouncing the user back into a session.
 */
const signedOut = ref(false);
const redirecting = ref(false);

onMounted(() => {
  try {
    signedOut.value = sessionStorage.getItem("smake.signedOut") === "1";
  } catch {
    signedOut.value = false;
  }
  if (!signedOut.value) {
    redirecting.value = true;
    window.location.assign(signInUrl());
  }
});

function signIn() {
  try {
    sessionStorage.removeItem("smake.signedOut");
  } catch {
    /* ignore */
  }
  window.location.assign(signInUrl());
}
</script>

<template>
  <div class="grid min-h-dvh place-items-center bg-gradient-to-b from-background to-muted/60 p-6">
    <div class="w-full max-w-sm rounded-xl border bg-card p-8 text-center shadow-sm">
      <div class="mb-6 flex justify-center"><BrandMark /></div>
      <template v-if="redirecting">
        <p class="text-sm text-muted-foreground" role="status">{{ t.auth.redirecting }}</p>
      </template>
      <template v-else>
        <h1 class="text-lg font-semibold">{{ signedOut ? t.auth.signedOutTitle : t.auth.signInTitle }}</h1>
        <p class="mt-1.5 text-sm text-muted-foreground">{{ signedOut ? t.auth.signedOutBody : t.auth.signInBody }}</p>
        <Button class="mt-6 w-full" size="lg" @click="signIn"><LogIn /> {{ t.auth.signIn }}</Button>
      </template>
    </div>
  </div>
</template>
